/**
 * Gate de “acelerador concluído” (aulas 3+, página Trade, WhatsApp no Help).
 * Coloque `true` para voltar a exigir acelerador nesses fluxos.
 */
export const REQUIRE_ACCELERATOR_FOR_PREMIUM_FEATURES = false;
